// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"3b314144","216":"835118dd","267":"90a19b4a","278":"6c9818fa","330":"20bcf79f","389":"a155b423","487":"cd464859","514":"5548610a","542":"cd6033a7","588":"049ccb3f"}[chunkId] + ".chunk.js";
};